// latest: zhangmyh 2017-9-13 8:18 PM
import 'ko-epui/dist/ko-epui.css'
import 'ko-epui'
import 'components'
import './index.less'
import '../common/home/header.less'
import initlayout from '../common/home/header.js'
import { Get } from 'common'
// 假数据
import testdata from '../../../mock/home.js'
import pageMgr from './manager_page'
import notice from 'model/notice'
// 轮播图
import 'static/jqueryplugins/unslider.min.js'
import 'static/jqueryplugins/slide.js'
import 'static/jqueryplugins/scroll.js'
let pic = require('static/img/home/banner1.png')
let piclist = [ pic ]
pic = require('static/img/home/banner2.png')
piclist.push(pic)
// title显示内容
let noticelist = [ '平台介绍', '客商注册', '客商分类', '供应商分级', '供应商认证', '供应商评价' ]
testdata.purchaser[0].url = require('static/img/home/suppliers/1.png')
testdata.purchaser[1].url = require('static/img/home/suppliers/2.png')
testdata.purchaser[2].url = require('static/img/home/suppliers/3.png')
testdata.purchaser[3].url = require('static/img/home/suppliers/4.png')
testdata.purchaser[4].url = require('static/img/home/suppliers/5.png')
testdata.purchaser[5].url = require('static/img/home/suppliers/6.png')
/* global ko $ */
pageMgr.init({
  id: window.global.query('id'),
  editable: window.global.query('edit'),
  pageType: window.global.query('type'),
  state: window.global.query('state'),
  from: window.global.query('from')
})

var viewModel

var handTop = 0

let selectSearchCombo = '01'

function init () {
  viewModel = {
    /* 搜索下拉框 绑定数据 */
    searchComboData: ko.observableArray([]),
    currentMenuId: ko.observable(''),
    initNotOver: ko.observable(true),
    title: ko.observable(noticelist[pageMgr.id - 1]),
    details: ko.observable(),
    filterContent: ko.observable(''),
    selectedSupplyCategory: ko.observable('01'),
    selectedSupplyCategoryName: ko.observable('采购分类'),
    categoryList: ko.observableArray([]),
    materialClassList: ko.observableArray(testdata.materalclass),
    announcementList: ko.observableArray(testdata.announcement),
    supplierList: ko.observableArray(testdata.supplier),
    supplierBlackList: ko.observableArray(testdata.supplierBlackList),
    purchaserList: ko.observableArray(testdata.purchaser),
    childrenCategoryList: ko.observableArray([]),
    welcomeText: ko.observable('未登录'),
    loginText: ko.observable('登录'),
    searchTypeText: ko.observable(''),
    registerText: ko.observable('注册'),
    hotlinepic: require('static/img/home/hotline.png'),
    ag1: require('static/img/home/ag1.png'),
    bidtitlepic: require('static/img/home/suppliers/bid_title.png'),
    piclist,
    arrowlpic: require('static/img/home/arrowl.png'),
    arrowrpic: require('static/img/home/arrowr.png'),
    noticeValue: ko.observable(notice.noticeValue),
    getChildrenCategoryList: function (pid) {
      let result
      let categoryList = this.categoryList()
      if (categoryList && categoryList.length > 0) {
        for (let i in categoryList) {
          if (categoryList[i].id == pid) {
            result = categoryList[i].children
            break
          }
        }
      }
      return result
    },
    onCateMouseOver: function (data, event) {
      let et = $(event.target)
      if (et[0].tagName == 'LI') {
        handTop = et.position().top
        viewModel.childrenCategoryList(viewModel.getChildrenCategoryList(data.value))
      }
      $('#category_list_content_hand').css('top', handTop)
      $('#category_list_content').show()
      $('#category_list_content_hand').show()
    },
    onCateMouseLeave: function (data, event) {
      $('#category_list_content').hide()
      $('#category_list_content_hand').hide()
    },
    onSelectCategory: function (data, event) {
      viewModel.selectedSupplyCategory(data.value)
      viewModel.selectedSupplyCategoryName(data.name)
    },
    searchByType: function () {
      if (selectSearchCombo == '02') {
        window.location.href = '../home_salesClassify/index.zh_CN.html?content=' + viewModel.filterContent()
      } else {
        window.location.href = '../classDescribeBySearch/index.zh_CN.html?content=' + viewModel.filterContent()
      }
    }
  }
  initlayout(viewModel)
  window.app = window.u.createApp({
    el: 'body',
    model: viewModel
  })

  $('.scroll-list').myScroll({
    speed: 40,  // 数值越大，速度越慢
    rowHeight: 35 // li的高度
  })
}

(function () {
  init()
  // 获取类目数据
  Get('/cpu-supplymgr/notice/oneNotice', { entid: window.global.user.PURCHASEID, id: pageMgr.id, typeId: 1 }).then(function (data, status) {
    if (data.status == 1) {
      viewModel.initNotOver(false)
      $('#noticeview').after(decodeURI(data.data.result.noticeValue))
      $('#main').height($('#content').height() + 60)
    }
  })
  // 判断登录
  viewModel.loadUser()
})()



// WEBPACK FOOTER //
// ./src/pages/home_noticeview/index.js